import './base.styl';
import './layout.styl';
import React from 'react';
import Helmet from 'react-helmet';
import {Match, Miss} from 'react-router';


import Search from '../components/search/Search';
import SearchPage from '../pages/search/SearchPage';
import Legal from '../pages/legal/Legal';
import Footer from '../components/footer/Footer';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';
import Banner from '../components/banner/Banner';

const NotFound = ({location}) =>
  <div>
    <div>404 Not Found for {location.pathname}</div>
  </div>;

const App = ({appType, intl: {locale, initialNow, currentLocale, defaultLocale, messages}}) =>
  <IntlProvider
    defaultLocale={defaultLocale}
    initialNow={initialNow}
    key={currentLocale}
    locale={currentLocale}
    messages={messages[currentLocale]}
  >

    <div className="layout">
      <Helmet htmlAttributes={{lang: currentLocale}} />
      <div className="layout__top">
        <div className="layout__top-inner clearfix">
          <div className="layout__top-right">ב"ה</div>
          {appType === 'international' &&
            <div className="layout__top-left">
              Combine languages + countries search / No ADs/ No personal data collection
            </div>
          }
        </div>
      </div>
      <div className="layout__container">
        <div className="layout__banner">
          <Match pattern="/" exactly component={Banner} />
        </div>
        <div className="layout__search">
          <Match pattern="/" exactly component={Search} />
          <Match pattern="/search" exactly component={Search} />
        </div>
        <div className="layout__content">
          <Match pattern="/search" component={SearchPage} />
          <Match pattern="/legal" component={Legal} />
          <Miss component={NotFound} />
        </div>
      </div>
      <div className="layout__footer">
        <Footer />
      </div>
    </div>
  </IntlProvider>;

export default connect(state => ({
  intl: state.intl,
  appType: state.config.appType
}))(App);



// WEBPACK FOOTER //
// ./src/client/app/App.js